import { useEffect, useState, useContext, FC } from 'react';
import cs from 'classnames';
import { isArray } from '@lhb/func';
import { post } from '@/common/request';
import { getFavoriteList } from '@/common/api/siteselectionmap';
import { CollectListContext } from '../../ts-config';
import styles from './index.module.less';
import { Dropdown, Input, Modal, Typography } from 'antd';
import IconFont from '@/common/components/IconFont';
import { MoreOutlined } from '@ant-design/icons';
import { V2Confirm } from '@/common/components/Others/V2Confirm';
import V2Message from '@/common/components/Others/V2Hint/V2Message';

/**
 * @Description 收藏列表左侧内容
 */
const LeftContent: FC<{
  requirementId, // 需求id
  open,
  leftKey,
  setLeftKey,
  folderNum,
  setFolderNum,
  isRefresh,
  setRefresh
}> = ({ requirementId, open, leftKey, setLeftKey, folderNum, setFolderNum, isRefresh, setRefresh }) => {
  const { collectList, setCollectList }: any = useContext(CollectListContext);

  const [editItem, setEditItem] = useState<any>({});
  const [editVisible, setEditVisible] = useState(false);
  const [folderList, setFolderList] = useState<any>([]);
  const [editLoading, setEditLoading] = useState(false);

  const menuItems = [
    { key: 'edit', label: '编辑信息' },
    { key: 'delete', label: '删除' }, // 0411版本暂时注释，接口还不支持
  ];

  useEffect(() => {
    if (!open) return;
    getFolderList();
  }, [open]);

  useEffect(() => {
    if (isRefresh) {
      getFolderList();
      setRefresh(false);
    };
  }, [isRefresh]);

  /* methods */
  /**
   * @description 获取文件夹列表
   */
  const getFolderList = () => {
    getFavoriteList({ requirementId }).then((res) => {
      const { favoriteFolderListVOS: data, siteLocationFlag } = res;
      setFolderList(isArray(data) ? data : []);
      if (data.length) {
        const currentItem = data.find((item) => item.id === leftKey);
        const result = currentItem?.id ? currentItem : data[0];
        setFolderNum({
          // clusterNum: result.clusterNum,
          siteLocationNum: result.siteLocationNum,
          siteLocationFlag: siteLocationFlag,
          name: result.name
        });
        setLeftKey(result.id);
      }
    });
  };
  const onMenuClick = (e, item) => {
    e.domEvent.stopPropagation();
    if (e.key === 'edit') {
      setEditItem({
        id: item.id,
        label: item.name
      });
      setEditVisible(true);
    } else if (e.key === 'delete') {
      deleteCollect(item.id);
    }
  };
  // 编辑收藏夹
  const confirmEditCollect = () => {
    if (!editItem.label) {
      V2Message.warning('请输入收藏夹名称');
      return;
    }
    setEditLoading(true);
    // https://yapi.lanhanba.com/project/546/interface/api/70195
    post('/clusterLocationFavor/saveFolder', { requirementId, name: editItem.label, id: editItem.id }, { needHint: true }).then(() => {
      V2Message.success(`${editItem.id ? '编辑' : '添加'}成功`);
      getFolderList();
      setEditVisible(false);
    }).finally(() => setEditLoading(false));

  };
  // 删除收藏夹
  const deleteCollect = (id: number) => {
    V2Confirm({ content: '确认删除此收藏夹吗？删除后收藏的内容将会丢失', onSure: (modal: any) => {
      modal.destroy();
      // https://yapi.lanhanba.com/project/546/interface/api/70202
      post('/clusterLocationFavor/deleteFolder', { id }, { needHint: true }).then((ids: any) => {
        V2Message.success('删除成功');
        getFolderList();
        if (isArray(ids) && ids.length) {
          const targetList = collectList.filter((itemId: number) => !ids.includes(itemId));
          setCollectList(targetList);
        }
      });
    } });
  };

  const folderChangeHandle = (item) => {
    setFolderNum({
      ...folderNum,
      // clusterNum: item.clusterNum,
      siteLocationNum: item.siteLocationNum,
      name: item.name
    });
    setLeftKey(item.id);
  };

  return (
    <div className={styles.left}>
      <div className={styles.leftHeader}>收藏夹（{folderList?.length}）</div>
      <div className={styles.collectList}>
        { folderList.map((item, index: number) => {
          const name = `${item.name}（${item.siteLocationNum}）`;
          return (
            <div key={item.id} className={cs(styles.listItem, leftKey === item.id && styles.listItemActive)} onClick={() => folderChangeHandle(item)}>
              <Typography.Text className={styles.listItemName} ellipsis={{ tooltip: name }}>{name}</Typography.Text>
              {/* 默认文件夹不展示更多 */}
              { index > 0 && (
                <Dropdown menu={{ items: menuItems, onClick: (e) => onMenuClick(e, item) }} trigger={['hover']} placement='bottomRight'>
                  <MoreOutlined className={styles.itemMore} onClick={e => e.stopPropagation()} />
                </Dropdown>
              ) }
            </div>
          );
        }) }
      </div>
      <div className={styles.leftFooter} onClick={() => {
        setEditItem({ label: '', id: '' });
        setEditVisible(true);
      }}>
        <IconFont iconHref='iconic_add_xiangqing' className='mr-4 fs-14 c-006' />
        添加收藏夹
      </div>
      <Modal
        title={editItem.id ? '编辑' : '添加收藏夹'}
        open={editVisible}
        onCancel={() => setEditVisible(false)}
        onOk={confirmEditCollect}
        confirmLoading={editLoading}
        centered
      >
        <Input
          value={editItem.label}
          onChange={(e) => setEditItem({ ...editItem, label: e.target.value })}
          showCount
          maxLength={10}
        />
      </Modal>
    </div>
  );
};

export default LeftContent;
